import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpEvent,
  HttpErrorResponse,
  HttpEventType,
} from "@angular/common/http";
import { BehaviorSubject, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { User } from "../models/user";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("currentUser")),
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(userName: string, password: string) {
    return this.http
      .post<any>(`${environment.apiUrl}auth/login`, {
        userName,
        password,
      })
      .pipe(
        map((user) => {
          // store user details and jwt token in local storage to keep user logged in between page refreshes

          localStorage.setItem("currentUser", JSON.stringify(user));
          this.currentUserSubject.next(user);
          return user;
        }),
      );
  }

  requestGetState(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "States";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBookrequisitionList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBookrequisitionList1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/authors1";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBookrequisitionList2(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/authors2";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBookrequisitionList3(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/authors3";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBookrequisitionList4(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/authors4";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBookrequisitionList5(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/authors5";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBookrequisitionList6(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/authors6";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetPrintrequisitionList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "printrequisition/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetCoverrequisitionList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "coverrequisition/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetGrnBinderList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grnbinder/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetGrnBinderList1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grnbinder/report";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  // stockReport(id: any): Observable<any>{
  //   let token = localStorage.getItem("MYTOKEN");
  //   let httpAuthOptions = {
  //     headers: new HttpHeaders(
  //       {
  //         'Content-Type': 'application/json',
  //         'Authorization': 'bearer ' + token,
  //       }
  //     ),
  //   };
  //   let URL = environment.apiUrl + 'grnbinder/stockreport/' + id;
  //   return this.http.get<any>(URL, httpAuthOptions).
  //   pipe(
  //     map(res =>{
  //       return res;
  //     })
  //   )
  // }

  stockReport(id: string, search: string = ""): Observable<any> {
    const token = localStorage.getItem("MYTOKEN");
    const httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      }),
    };

    // Construct URL with optional search param
    let URL = `${environment.apiUrl}grnbinder/stockreport/${id}`;
    if (search) {
      URL += `?search=${encodeURIComponent(search)}`;
    }

    return this.http.get<any>(URL, httpAuthOptions).pipe(map((res) => res));
  }

  requestGetBindingrequisitionList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bindingrequisition/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetLaminationrequisitionList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "laminationrequisition/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  billinglogoUpload(id, formData) {
    return this.http
      .post<any>(
        `${environment.apiUrl + "billingaddress/upload/" + id}`,
        formData,
        {
          reportProgress: true,
          observe: "events",
        },
      )
      .pipe(
        map((event) => this.getEventMessage(event, formData)),
        //catchError(this.handleError)
      );
  }
  myprofile(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Profile";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  userregistration(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "stockpoint/stockpoints";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  userlist(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "auth/users";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  addminusStockList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "addminusstock/list";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  addminusStockAdd(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "addminusstock/create";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  addminusStockDetail(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "addminusstock/detail/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  stateList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "state/state";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  terminalList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "stockpoint/terminallist";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  studentadd(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Students";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetCompany(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");

    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "company/company";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  updateCompany(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "company/company";
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  requestGetUserList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "auth/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteUser(userId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "auth/delete/" + userId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  approveBook(userId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/author1/" + userId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getUser(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "auth/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getWallet(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "UserWallets/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateUser(userId, data): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "auth/user/" + userId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateRequisition(userId, data): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/author/" + userId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateUsername(userId, data): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "auth/username/" + userId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addUser(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "auth/signup";
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getEnquiry(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "enquiry/enquiry/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetEnquiry(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "enquiry/enquiries";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  enquiryadd(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "enquiry/enquiry";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetCategoryList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "category/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetCategoryListC(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "category1/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetCategoryList1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "category/authors1";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetCategoryListC1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "category1/authors1";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBrandList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "brand/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetTaxList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "tax/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  requestGetProductList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetProductLists(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/authorss";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetVendorstockList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendorstock/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBookApproveList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookapprove/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetRoleList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "role/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetProductList1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/booklist";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  requestGetVendorcategoryList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendorcategory/bookcategories";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  requestGetItemgroupList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "itemgroup/bookcategories";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  requestGetAuthorList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "author/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetUnitList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "unit/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetJobList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "job/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetFreeList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "freeisbn/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetDailyList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "dailyentry/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetLetterList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "letter/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBillingList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "billingaddress/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBankList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bankdetail/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetPurchaseList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchase/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetPurchaseList1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "otherpurchase/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetGrnList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  requestGetGrnList3(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/salesorder";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  requestGetGrnList2(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/vendors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetGrnList1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/all";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  stockMovement(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/stockmovement";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  requestGetConsumptionList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paperconsumption/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetSaleList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetAccountTypeList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "accounttype/authors1";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetAccountTypeList1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "accounttype/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetAccountType(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "accounttype/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  accountList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "account/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getAccount(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "account/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addAccount(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "account/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  editAccount(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "account/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteAccount(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "account/author/" + id;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteAccounttype(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "accounttype/author/" + id;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetSaleListCancell(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/cancel";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetSaleListPending(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/placed";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetSaleList1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/report";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  receivableList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "receivable/list";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  expensesList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "expenses/list";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  createExpense(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "expenses/create";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  expenseDetail(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "expenses/detail/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  journalList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "expenses/journal-list";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  createJournal(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "expenses/create-journal";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  journalDetail(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "expenses/journal-detail";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  journalEdit(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "expenses/detail-journal/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  documentIdFormatDetail(id: number): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL =
      environment.apiUrl + "productsaleformat/getbillingaddressIdAuthor/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  receivableDetail(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "receivable/detail/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  addReceivable(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "receivable/create";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  requestGetSaleList2(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/report1";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetOutsourceList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "outsource/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetPaymentList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paymentterm/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetLogisticList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "logisticdetail/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetEwayuomList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "ewayuom/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetUomList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "uom/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBsaList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bsa/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetItemCategoryList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/author2";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetVendorsList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bsa/vendors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetCustomerList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bsa/customers";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getAttachment(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "receivable/attachment/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  customerPendingBills(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/customer-pending-bill/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  requestGetTransporterList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bsa/transporters";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBuyersList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bsa/buyers";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBuyerCompany(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bsa/company";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetDeliveryCompany(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "deliveryaddress/company";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetStoreList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "store/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetProductnoList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productnoformat/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetProductorderList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productorderformat/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetProductsaleList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productsaleformat/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetProductgrnList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productgrnformat/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetProductoutsourceList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productoutsourceformat/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetTermconditionList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "termcondition/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetDeliveryList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "deliveryaddress/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetCommissionList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "commission/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetStateList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "state/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBookList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "book/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetVendorList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendor/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetItemList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "item/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetMarketingList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "marketing/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetCustomertypeList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "customertype/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetDistrictList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "district/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGeSubjectList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "subject/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getGameList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "game/games";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  gameadd(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "game/game";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getGame(gameId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "game/game/" + gameId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  gamedelete(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "game/game/" + id;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetGame(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "game/gamerates";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  plrList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "stockpoint/plrlist";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  searchGame(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "gameassign/gameassign/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addgame(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "gameassign/gameassign";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  plrDashboard(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "PlrDashboard";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  searchPlrList(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StockPoints2/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteCategory(categoryId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookcategory/bookcategory/" + categoryId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteCategoryC(categoryId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "category1/author/" + categoryId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteVendorcategory(categoryId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendorcategory/bookcategory/" + categoryId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteItemgroup(categoryId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "itemgroup/bookcategory/" + categoryId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteAuthor(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "author/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteCustomertype(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "customertype/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteBook(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "book/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteGrn(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grnbinder/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteBilling(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "billingaddress/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteDelivery(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "deliveryaddress/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteBank(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bankdetail/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteProduct(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  approveOutsource(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "outsource/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteStore(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "store/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteSale(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  deletePermanent(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/deletePermanent/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  deletesaleDetailsPermanent(authorId, billId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL =
      environment.apiUrl + "sale/delete/saledetails/" + authorId + "/" + billId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteStatus(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/deleteStatus/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  deletePurchase(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchase/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  gettranspoterdetails(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bsa/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getGrnPurchase(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/purchase/" + authorId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  deletePayment(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paymentterm/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteLogistic(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "logisticdetail/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteUom(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "uom/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteProductno(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productnoformat/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteProductorder(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productorderformat/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteProductsale(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productsaleformat/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteProductgrn(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productgrnformat/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteProductoutsource(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productoutsourceformat/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteBsa(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bsa/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteTermcondition(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "termcondition/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteVendor(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendor/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteBookdetail(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookdetail/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteVendordetail(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendordetail/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteCommission(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "commission/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteUnit(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "unit/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  deleteJob(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "job/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteItem(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "item/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deletePrinterBinder(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "printrequisition/binder/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteMarketing(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "marketing/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteCustomer(authorId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "customer/author/" + authorId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getCategory(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookcategory/bookcategory/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getBookRequisition(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getPrintRequisition(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "printrequisition/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getPrintRequisition1(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "printrequisition/author1/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getCoverRequisition(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "coverrequisition/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getCoverRequisition1(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "coverrequisition/author1/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getCoverRequisition2(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "printrequisition/author2/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getCoverRequisition3(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "laminationrequisition/author2/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getLaminationRequisition1(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "laminationrequisition/author1/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getBindingRequisition(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bindingrequisition/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getBindingRequisition1(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bindingrequisition/author1/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getBindingRequisition2(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bindingrequisition/author2/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getLaminationRequisition(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "laminationrequisition/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getGrnBinder(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grnbinder/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateGrnBinder(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grnbinder/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getGrnBinder1(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grnbinder/author1/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getBookRequisition1(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/author1/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  formalist(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/formalist/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  formadeliverlist(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/formadeliverlist/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  booklist(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "coverrequisition/booklist/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  coverReceive(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bindingrequisition/coverreceive";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  formalistPartner(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/formalistprinter/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  formaReceive(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bindingrequisition/formareceive";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getFormaReceive(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bindingrequisition/getformareceive";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deliverforma(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/deliverforma/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getBinderList(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "printrequisition/binderlist/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  formalist1(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/formalist1";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getCategoryC(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "category1/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getVendorcategory(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendorcategory/bookcategory/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getItemgroup(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "itemgroup/bookcategory/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getAuthor(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "author/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getUnit(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "unit/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getJob(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "job/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getFree(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "freeisbn/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getDaily(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "dailyentry/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getLetter(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "letter/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getBilling(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "billingaddress/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  saveStock(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grnbinder/savestock/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  bulkSaveStock(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grnbinder/bulk-save-stock/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getSettings(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "settings";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getBank(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bankdetail/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getProduct(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getProduct1(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/author1/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  filteritemNameAuthor1(id: number, itemName: string = ""): Observable<any> {
    const token = localStorage.getItem("MYTOKEN");
    const httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      }),
    };

    const URL = `${environment.apiUrl}product/filteritemNameAuthor1/${id}?itemName=${encodeURIComponent(itemName)}`;

    return this.http.get<any>(URL, httpAuthOptions).pipe(map((res) => res));
  }

  productForBilling(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/productForBilling/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getProductStock(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/getProductStock";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getBookapprove(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookapprove/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getPurchase(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchase/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getPurchase1(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "otherpurchase/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getInventory(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "inventory/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getInventory1(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "inventory/author1/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getGrn(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getConsumption(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paperconsumption/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getConsumptionReport(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paperconsumption/report/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetProductListss(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/authorss";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getTax(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "tax/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getSale(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getCreditnote(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "creditnote/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getDebitnote(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "debitnote/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getBillingAddressDetails(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bankdetail/billingaddressdata/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getSale1(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/getsalesorder";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getOutsource(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "outsource/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getStore(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "store/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getPayment(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paymentterm/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getBillingList(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "billingaddress/list/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getLogistic(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "logisticdetail/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getUom(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "uom/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getBsa(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bsa/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getState(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "state/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getProductno(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productnoformat/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getProductorder(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productorderformat/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getProductsale(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productsaleformat/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  lastBill(billingaddressId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/lastBill/" + billingaddressId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getProductgrn(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productgrnformat/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getProductoutsource(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productoutsourceformat/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getTermcondition(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "termcondition/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getDelivery(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "deliveryaddress/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getCommission(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "commission/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getBook(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "book/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getVendor(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendor/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getCustomer(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "customer/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getMarketing(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "marketing/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getItem(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "item/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getCustomertype(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "customertype/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getCategoryList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Categories1";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateCategory(categoryId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookcategory/bookcategory/" + categoryId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateBookRequisition(categoryId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/author/" + categoryId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateCategoryC(categoryId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "category1/author/" + categoryId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateVendorcategory(categoryId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendorcategory/bookcategory/" + categoryId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateItemgroup(categoryId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "itemgroup/bookcategory/" + categoryId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateAuthor(authorId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "author/author/" + authorId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateUnit(authorId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "unit/author/" + authorId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateJob(authorId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "job/author/" + authorId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateCommission(authorId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "commission/author/" + authorId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateCustomer(authorId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "customer/author/" + authorId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateBook(authorId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "book/author/" + authorId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateBookdetail(authorId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "book/bookdetail/" + authorId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateVendor(authorId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendor/author/" + authorId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateMarketing(authorId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "marketing/author/" + authorId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateItem(authorId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "item/author/" + authorId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateCustomertype(authorId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "customertype/author/" + authorId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateDistrict(districtId, data): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "district/author/" + districtId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addCategory(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "category/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addBookrequisition(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addPrintrequisition(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "printrequisition/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addCoverrequisition(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "coverrequisition/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addGrnbinder(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grnbinder/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addBindingrequisition(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bindingrequisition/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getRequisition(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bindingrequisition/getRequisition";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getBinderBook(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bindingrequisition/getBinderBook";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  addLaminationrequisition(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "laminationrequisition/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addCategoryC(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "category1/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addAccountType(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "accounttype/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  editAccountType(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "accounttype/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addVendorcategory(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendorcategory/bookcategory";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addItemgroup(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "itemgroup/bookcategory";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addAuthor(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "author/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addUnit(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "unit/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addJob(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "job/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addFree(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "freeisbn/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addDaily(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "dailyentry/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addLetter(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "letter/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addCommission(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "commission/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addCustomer(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "customer/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addBook(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "book/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addBrand(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "brand/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addVendor(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendor/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  addBookdetail(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookdetail/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addVendordetail(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendordetail/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addItem(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "item/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addMarketing(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "marketing/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addCustomertype(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "customertype/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addDistrict(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "district/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addWallet(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "userwallet/userwallet";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addSubject(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "subject/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addRole(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "role/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getRole(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "role/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateRole(userId, data): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "role/author/" + userId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addTime(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "BatchTimes";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetCourseList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatCourses";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteCourse(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatCourses/" + courseId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteBookAuthor(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/bookauthor/" + courseId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteBookApprove(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookapprove/author/" + courseId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  deleteBookRequisition(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/author/" + courseId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deletePrintRequisition(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "printrequisition/author/" + courseId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteCoverRequisition(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "printrequisition/author/" + courseId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteBindingRequisition(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bindingrequisition/author/" + courseId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteLaminationRequisition(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "laminationrequisition/author/" + courseId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteBookRequisitionItem(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookrequisition/item/" + courseId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deletePrintRequisitionItem(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "printrequisition/item/" + courseId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  deleteBookApproveDetail(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookapprove/book/" + courseId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  approveBookApproveDetail(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookapprove/approvebook/" + courseId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addCouse(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatCourses";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addChapter(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatChapters";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getChapter(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatChapters/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getQuestion(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TopicQuestions/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getSuperStockist(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "stockpoint/stockpoint/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getUser1(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "auth/user/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateCourse(courseId, data): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatCourses/" + courseId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateSuperstockist(superstockistId, data): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL =
      environment.apiUrl + "stockpoint/updatestockpoint/" + superstockistId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateTime(timeId, data): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "BatchTimes/" + timeId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateQuestion(questionId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TopicQuestions/" + questionId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateChapter(chapterId: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatChapters/" + chapterId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteChapter(chapterId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatChapters/" + chapterId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteTime(timeId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "BatchTimes/" + timeId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteTopic(topicId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatTopics/" + topicId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addTopic(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatTopics";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteLink(topicId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TopicLinks/" + topicId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addLink(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TopicLinks";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addYoutube(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TopicYoutube";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteQus(topicId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TopicQuestions/" + topicId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addQuestion(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TopicQuestions";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addSuperstockist(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "stockpoint/stockpoint";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  studentBatch(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StudentBatches";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  teacherBatch(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TeacherBatches";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateSubject(subjectId, data): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "subject/author/" + subjectId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateTopic(topicId, data): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatTopics/" + topicId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteSubject(subjectId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "subject/author/" + subjectId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteDistrict(subjectId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "district/author/" + subjectId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getCourse(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatCourses/" + courseId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getDistrict(districtId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "district/author/" + districtId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getTopic(topicId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatTopics/" + topicId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getSubjectList1(courseId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "GetsatSubjects1/" + courseId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getSubject(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "subject/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetTeacherList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Teachers";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetTeacherList1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TeacherPagination";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetSsList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StockPoints/Superstockpoint";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  userLimitationList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "userlimitation/userlimitations";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  userWalletList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "stockpoint/userwalletlist";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  userWalletList1(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "userwallet/userwalletlist/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetSList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StockPoints/Stockpoint";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetStockpoint(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StockPoints1/Stockpoint";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  pageList(url: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = url;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getTeacher(teacherId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Teachers/" + teacherId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getSubjectList(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "SubjectList";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getCourseList(categoryId: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "CourseList/" + categoryId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateTeacher(teacherId, data): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Teachers/" + teacherId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateBatch(batchId, data): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Batches/" + batchId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateLimitation(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "userlimitation/userlimitation/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updatePayout(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "stockpoint/updatepayout/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updatePayoutList(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "stockpoint/updateallpayout";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteTeacher(teacherId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Teachers/" + teacherId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteStockist(stockistId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "stockpoint/stockpoint/" + stockistId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteBatch(batchId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Batches/" + batchId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  upload(id, formData) {
    return this.http
      .post<any>(`${environment.apiUrl + "StudentImage/" + id}`, formData, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => this.getEventMessage(event, formData)),
        //catchError(this.handleError)
      );
  }
  upload1(id, formData) {
    return this.http
      .post<any>(`${environment.apiUrl + "FatherImage/" + id}`, formData, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => this.getEventMessage(event, formData)),
        //catchError(this.handleError)
      );
  }
  upload2(id, formData) {
    return this.http
      .post<any>(`${environment.apiUrl + "MotherImage/" + id}`, formData, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => this.getEventMessage(event, formData)),
        //catchError(this.handleError)
      );
  }
  upload3(id, formData) {
    return this.http
      .post<any>(`${environment.apiUrl + "TeacherImage/" + id}`, formData, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => this.getEventMessage(event, formData)),
        //catchError(this.handleError)
      );
  }

  upload4(id, formData) {
    return this.http
      .post<any>(`${environment.apiUrl + "AddressImage/" + id}`, formData, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => this.getEventMessage(event, formData)),
        //catchError(this.handleError)
      );
  }

  upload5(id, formData) {
    return this.http
      .post<any>(`${environment.apiUrl + "XResultImage/" + id}`, formData, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => this.getEventMessage(event, formData)),
        //catchError(this.handleError)
      );
  }

  upload6(id, formData) {
    return this.http
      .post<any>(`${environment.apiUrl + "XiiResultImage/" + id}`, formData, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => this.getEventMessage(event, formData)),
        //catchError(this.handleError)
      );
  }
  upload7(id, formData) {
    return this.http
      .post<any>(
        `${environment.apiUrl + "CollegeResultImage/" + id}`,
        formData,
        {
          reportProgress: true,
          observe: "events",
        },
      )
      .pipe(
        map((event) => this.getEventMessage(event, formData)),
        //catchError(this.handleError)
      );
  }
  upload8(id, formData) {
    return this.http
      .post<any>(`${environment.apiUrl + "TopicImage/" + id}`, formData, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => this.getEventMessage(event, formData)),
        //catchError(this.handleError)
      );
  }
  upload9(id, formData) {
    return this.http
      .post<any>(`${environment.apiUrl + "TopicPdf/" + id}`, formData, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => this.getEventMessage(event, formData)),
        //catchError(this.handleError)
      );
  }
  upload10(id, formData) {
    return this.http
      .post<any>(`${environment.apiUrl + "TopicVideo/" + id}`, formData, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => this.getEventMessage(event, formData)),
        //catchError(this.handleError)
      );
  }

  private getEventMessage(event: HttpEvent<any>, formData) {
    switch (event.type) {
      case HttpEventType.UploadProgress:
        return this.fileUploadProgress(event);
        break;
      case HttpEventType.Response:
        return this.apiResponse(event);
        break;
      default:
        return `File "${formData.get("profile").name}" surprising upload event: ${event.type}.`;
    }
  }

  private fileUploadProgress(event) {
    const percentDone = Math.round((100 * event.loaded) / event.total);
    return { status: "progress", message: percentDone };
  }

  private apiResponse(event) {
    return event.body;
  }

  changepassword(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "auth/password/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addteachercourse(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TeacherCourses";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  daterangepurchase(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchase/daterange";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  daterangesale(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/daterange";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  daterangebooksale(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grnbinder/datewisebookstock";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  journalReport(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "journal/report";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  lamination_daterangesale(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "laminationrequisition/lamination-report";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  cover_daterangesale(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "coverrequisition/cover-report";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  print_daterangesale(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "printrequisition/print-report";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addteacher(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Teachers";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addBatch(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Batches";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  allotCourse(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StudentCourseAllots";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  teachercoursedelete(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TeacherCourses/" + id;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetStudentList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Students";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetStudentList2(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StudentList";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetTeacherList2(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TeacherList";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetBatchList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Batches";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetStudentList1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StudentPagination";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetPList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StockPoints/Plr";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  requestGetPlr(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StockPoints1/Plr";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  myProfile1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "stockpoint/myprofile";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getStudent(studentId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Students/" + studentId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getTime(timeId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "BatchTimes/" + timeId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getBatch(batchId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Batches/" + batchId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getBatchStudent(batchId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StudentBatches/" + batchId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getAllotedCourseList(studentId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StudentCourseAllots/" + studentId;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addStudent(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Students";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  deleteStudent(studentId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Students/" + studentId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteStudentBatch(studentId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StudentBatches/" + studentId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteStudentBatch1(studentId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StudentBatches1/" + studentId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteTeacherBatch(teacherId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TeacherBatches/" + teacherId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  deleteTeacherBatch1(teacherId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "TeacherBatches1/" + teacherId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  deleteAllot(allotId): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "StudentCourseAllots/" + allotId;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  updateStudent(studentId, data): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Students/" + studentId;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updatePin(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "stockpoint/updatepin/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateBilling(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "billingaddress/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateBillingAccess(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "auth/access/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateBank(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bankdetail/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateProduct(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateBookApprove(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookapprove/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateStore(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "store/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updatePayment(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paymentterm/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateLogistic(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "logisticdetail/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateUom(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "uom/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateBsa(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bsa/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateProductno(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productnoformat/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateProductorder(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productorderformat/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateProductsale(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productsaleformat/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateProductgrn(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productgrnformat/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateProductoutsource(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productoutsourceformat/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateTermcondition(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "termcondition/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateDelivery(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "deliveryaddress/author/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateTerminal(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "stockpoint/updateterminal/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  siblingdelete(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Siblings/" + id;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  siblingadd(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "Siblings";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addBilling(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "billingaddress/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addBank(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bankdetail/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addProduct(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  stockDetail(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "vendorstock/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateStockAdd(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "updatestock/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  stockTransferList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "billingstocktransfer/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  stockTransfer(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "stocktransfer/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addBillingStockTransfer(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "billingstocktransfer/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  viewBillingStockTransfer(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "billingstocktransfer/author/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  updateStockReduce(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "updatestock/author1";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  currentStock(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "updatestock/current";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addBookApprove(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bookapprove/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addPurchase(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchase/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addPurchase1(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "otherpurchase/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  searchPurchase(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchase/search";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  searchPurchase1(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "otherpurchase/search";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addGrn(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  stockTransferNew(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/transfer";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  stockTransferNew1(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/transfer1";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  selfStock(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/selfstock";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  binderlist(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bindingrequisition/binderlist/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  myStock(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "inventory/mystock/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addConsumption(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paperconsumption/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getConsumptionReport1(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paperconsumption/report";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getInvent(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paperconsumption/author1";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addGrn1(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/create";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  addGrnSale(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/salesordergrn";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getInventoryDetail(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/billing";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getInventoryDetail1(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/bsa";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addSale(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  draftSale(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/draft";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  editSale(data: any, id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/edit/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  editDraftSale(data, id): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/editdraft/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  addSale1(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/add_sale";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  addCreditnote(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "creditnote/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  addDebitnote(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "debitnote/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  customerLedger(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/customer-ledger";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  customerClosingBalance(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/customer-closing-balance";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  financialyears(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/financial-years";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  financialyears1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/financialyears";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  vendorLedger(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchase/vendor-ledger";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  customerLedgerAll(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/customer-ledger-all";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  customerLedgerAll_Debtors(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "customer-ledger/data";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  vendorLedgerAll(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchase/vendor-ledger-all";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  addOutsource(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "outsource/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addStore(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "store/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getProductList(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "product/author1";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getPurchaseList(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchase/author1";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getPurchaseList1(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "otherpurchase/author1";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getSaleList(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/author1";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getGrnList(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "grn/author1";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  getOutsourceList(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "outsource/author1";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addPayment(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paymentterm/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addLogistic(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "logisticdetail/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addEwayuom(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "ewayuom/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addUom(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "uom/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addBsa(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bsa/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addProductno(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productnoformat/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addProductorder(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productorderformat/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addProductsale(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productsaleformat/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addProductgrn(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productgrnformat/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addProductoutsource(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "productoutsourceformat/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addTermcondition(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "termcondition/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }
  addDelivery(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "deliveryaddress/author";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  purchaseMadeList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchasemade/list";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  paymentMadeList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paymentmade/list";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  updateClear(id: any, data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paymentmade/update/" + id;
    return this.http.put<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  purchaseMadeDetail(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchasemade/detail/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  paymentMadeDetail(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paymentmade/detail/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  vendorList1(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "bsa/vendors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getPurchaseVendor(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchase/purchaselist/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  getSaleDueList(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paymentmade/sale-due-list/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  addPurchaseMade(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchasemade/create";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  addPaymentMade(data: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "paymentmade/create";
    return this.http.post<any>(URL, data, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  creditnoteList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "creditnote/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  deletecreditnote(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "creditnote/delete/" + id;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  customerBill(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/customer-bill/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  _itemList1(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "sale/bill-items/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  _purchaseItemList1(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchase/bill-items/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  debitnoteList(): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "debitnote/authors";
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  deletedebitnote(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "debitnote/delete/" + id;
    return this.http.delete<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  vendorBill(id: any): Observable<any> {
    let token = localStorage.getItem("MYTOKEN");
    let httpAuthOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "bearer " + token,
      }),
    };
    let URL = environment.apiUrl + "purchase/customer-bill/" + id;
    return this.http.get<any>(URL, httpAuthOptions).pipe(
      map((res) => {
        return res;
      }),
    );
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("currentUser");
    localStorage.removeItem("MYTOKEN");
    localStorage.removeItem("USERNAME");
    localStorage.removeItem("USERTYPE");
    localStorage.removeItem("USERID");
    localStorage.removeItem("USERCODE");
    localStorage.removeItem("MYSRC");
    localStorage.removeItem("BILLINGID");
    localStorage.removeItem("menus");
    this.currentUserSubject.next(null);
    return of({ success: false });
  }
}
